import {ApiErrorResponse, TypedApiResponse} from 'src/types';

export const isSuccess = (response: TypedApiResponse<any> | ApiErrorResponse | Error): response is TypedApiResponse<any> => {
  return 'status' in response && response.status === 'success';
};

export const isError = (response: TypedApiResponse<unknown> | ApiErrorResponse | Error): response is ApiErrorResponse => {
  return 'status' in response && response.status === 'error';
};
